import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';
import { PatientGroup } from 'src/app/data/dietitian/domain/patient_group/patient_group';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[patient-group-row]',
  templateUrl: './patient-group-row.component.html',
  styleUrls: ['./patient-group-row.component.scss'],
})
export class PatientGroupRowComponent {
  @Input() patientGroup: PatientGroup;
  @Output() onEdit = new EventEmitter();
  @Output() onDelete = new EventEmitter();

  get formatedUpdatedAt(): string {
    return moment(this.patientGroup.updatedAt).format('DD.MM.yyyy');
  }

  public offsetDropdown(bAct: HTMLButtonElement, height: number): boolean {
    const pos = bAct.getBoundingClientRect();
    return window.innerHeight - (pos.top + window.scrollY) - height < 0;
  }
}
